// src/services/couponService.js

import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token =
        localStorage.getItem("authToken");

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":
                "application/json",
        },
    };
};

/* =========================
   FETCH COUPONS
========================= */
export const getCoupons = async () => {

    const response = await axios.get(
        `${BASE_URL}/promotions/api/admin/getall/coupons`,
        getAuthHeader()
    );

    return response.data;
};


export const getuserCoupons = async () => {

    const response = await axios.get(
        `${BASE_URL}/food/api/coupon`,
        getAuthHeader()
    );

    return response.data;
};
/* =========================
   FETCH COMPANIES
========================= */
export const getCompanies = async () => {

    const response = await axios.get(
        `${BASE_URL}/subscription/api/admin/enquiries/getall`,
        getAuthHeader()
    );

    return response.data;
};

/* =========================
   CREATE COUPON
========================= */
export const createCoupon = async (
    payload
) => {

    const response = await axios.post(
        `${BASE_URL}/promotions/api/admin/create/coupon`,
        payload,
        getAuthHeader()
    );

    return response.data;
};


export const createuserCoupon = async (formData) => {
    const token = localStorage.getItem("authToken");

    try {
        // Debug FormData
        for (const pair of formData.entries()) {
            //console.log(pair[0], pair[1]);
        }

        const response = await axios.post(
            `${BASE_URL}/food/api/coupon`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            }
        );

        return response.data;

    } catch (error) {

        console.error("Coupon API Error:", error);

        if (error.response) {
            //console.log("Status :", error.response.status);
            //console.log("Response :", error.response.data);
        }

        throw error;
    }
};


export const getAdvertisement = async (
    adminId,
    token
) => {
    const response = await axios.get(
        `${BASE_URL}/admin/${adminId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                accept: "*/*",
            },
        }
    );

    return response.data;
};

// ======================
// ADD ADVERTISEMENT
// ======================
export const addAdvertisement = async (
    adminId,
    formData,
    token
) => {
    const response = await axios.post(
        `${BASE_URL}/food/superadmin/advertisement/add/${adminId}`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":
                    "multipart/form-data",
            },
        }
    );

    return response.data;
};

// ======================
// UPDATE ADVERTISEMENT
// ======================
export const updateAdvertisement =
    async (
        adId,
        formData,
        token
    ) => {
        const response =
            await axios.put(
                `${BASE_URL}/food/superadmin/advertisement/edit/${adId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":
                            "multipart/form-data",
                    },
                }
            );

        return response.data;
    };

// ======================
// DELETE ADVERTISEMENT
// ======================
export const deleteAdvertisement =
    async (adId, token) => {
        const response =
            await axios.delete(
                `${BASE_URL}/food/superadmin/advertisement/delete/${adId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

        return response.data;
    };